// 德国语言
export const common = {
  cancel:"Abbrechen",
  confirm:"Bestätigen",
  country:"Land"
};
// 订单列表页面
export const orderList = {
  title:"Bestellliste",
};

// 查询页面
export const cardLoop = {
  cardTitle:"ICCID-Nummer der SIM-Karte",
  cardDesc:"Geben Sie die ICCID-Nummer der SIM-Karte in das Eingabefeld ein.",
  query:"Suche",//查询按钮
  title:"IoT SIM-Kartenplattform",
};

// 详情页面
export const cardInfo = {
  title:"Karteninformationen",
  msisdn:"MSISDN：",
  iccid:"ICCID：",
  expiration:"Ablauf：",//过期时间
  status:"Zustand",
  refresh:"Aktualisierung",//刷新
  residualFlow:"Restfluss",//剩余流量
  totalFlow:"Gesamtfluss",//总流量
  used:"Gebraucht",//已使用
  lists:["Verwenden","Ungebraucht","Gebraucht"],//tab切换 1 生效中 2 未生效 3.已失效
  validity:"Gültigkeitszeitraum",//套餐有效期
  skuUsed:"Gebraucht",//套餐已用
  skuTotal:"Gesamtfluss",//套餐总量
  recharge:"Aufladen",//去充值
};

// 选套餐页面
export const cardPlans = {
  title:"Paketliste",
  buyPlan:'Kaufen Plan',
  select:"bitte auswählen",//未选套餐的提示
  orderList:"Bestellliste",
  userAgreement:"Nutzungsvereinbarung",
  price:"Pauschalpreis",
  flowCount:"Gesamtfluss",
  validityTime:"Datum des Inkrafttretens",
  switchCountryName:"Nutzfläche",
  productDesc:"Paketbeschreibung",
  productDescText:"Vorauszahlung",
  paymentMethod:"Zahlungsmethode",
  checkUserAgreementMsg:"Bitte überprüfen Sie die Nutzungsvereinbarung",
  payErrorMsg:"Die gabelform wird die zahlung des yuan nicht unterstützen",
  payBtnText:"Avec",
};

// 完成支付或取消支付
export const cardPayEnd = {
  title:"Zahlungsergebnisse",
  Details:"Einzelheiten",//返回详情
};

export const country = {
  America:'Amerika',
  HongKong:'Hongkong',
  Thailand:'Thailand',
  Philippines:'Philippinen',
  Macao:'Macao'
}

// 位置标签
export const placeTitle = "Land";
// 国家名称
export const China = "China"
export const America = "Amerika"
export const HongKong = "Hongkong"







